import { useUser } from '@/client/context/user'
import type { Query } from '@/client/query'

import getSeriesBoxProps from './getSeriesBoxProps'
import SeriesBox from './SeriesBox'

interface SeriesBoxFromQueryProps {
  series: Query
  noMaxLearners?: boolean
  grayIfFull?: boolean
  variant?: 'gray' | 'primary'
  disableWithTooltip?: string
  hideSeriesHeader?: boolean
  openLinksInNewTab?: boolean
  disableLink?: boolean
}

const SeriesBoxFromQuery: React.FC<SeriesBoxFromQueryProps> = ({
  series,
  noMaxLearners = false,
  grayIfFull = false,
  variant = 'gray',
  disableWithTooltip,
  hideSeriesHeader = false,
  openLinksInNewTab = false,
  disableLink,
}) => {
  const user = useUser()
  const props = getSeriesBoxProps({ series, currentUserId: user.id })

  return (
    <SeriesBox
      {...props}
      noMaxLearners={noMaxLearners}
      grayIfFull={grayIfFull}
      variant={variant}
      disableWithTooltip={disableWithTooltip}
      hideSeriesHeader={hideSeriesHeader}
      openLinksInNewTab={openLinksInNewTab}
      disableLink={disableLink}
    />
  )
}

export default SeriesBoxFromQuery
